import type { BarcodeDetector as Ponyfill, BarcodeFormat } from "barcode-detector/ponyfill";
import wasmUrl from "zxing-wasm/reader/zxing_reader.wasm?url";

/*
 * Скан камерой телефона. Где есть нативный BarcodeDetector (Chrome на
 * Android), берём его. Где нет (Safari на iPhone), barcode-detector: тот же
 * интерфейс поверх zxing-cpp в WebAssembly. Так было и в chmk_base
 * (scan/camera_scan.js): ZXing-js не читал QR серийника версии 3 с
 * коррекцией H, zxing-cpp читает. Файл .wasm отдаёт наш сервер, не CDN:
 * без этого библиотека пошла бы за ним на jsDelivr.
 */

// Полка это Code128, серийник QR, товар поставщика EAN-13. Меньше форматов,
// быстрее кадр.
const FORMATS: BarcodeFormat[] = ["code_128", "qr_code", "ean_13"];

type Detector = Pick<Ponyfill, "detect">;

let detector: Promise<Detector> | undefined;

export function getDetector(): Promise<Detector> {
  detector ??= (async () => {
    const native = (window as unknown as { BarcodeDetector?: typeof Ponyfill }).BarcodeDetector;
    if (native) {
      const supported = await native.getSupportedFormats();
      const formats = FORMATS.filter((f) => supported.includes(f));
      if (formats.length > 0) return new native({ formats });
    }
    const { BarcodeDetector, prepareZXingModule } = await import("barcode-detector/ponyfill");
    prepareZXingModule({
      overrides: { locateFile: (path: string, prefix: string) => (path.endsWith(".wasm") ? wasmUrl : prefix + path) },
    });
    return new BarcodeDetector({ formats: FORMATS });
  })();
  return detector;
}

/** Камера есть и экран сенсорный: на ПК сканер-клавиатура, камера не нужна. */
export function canUseCamera(): boolean {
  // mediaDevices нет вне HTTPS: типы DOM об этом не знают.
  return "mediaDevices" in navigator && window.matchMedia("(pointer: coarse)").matches;
}

/**
 * Задняя камера в 1920×1080: по умолчанию браузер даёт 640×480, и QR
 * серийника 11 мм выходит в полтора пикселя на модуль (chmk_base).
 */
export function openCamera(): Promise<MediaStream> {
  return navigator.mediaDevices.getUserMedia({
    audio: false,
    video: { facingMode: { ideal: "environment" }, width: { ideal: 1920 }, height: { ideal: 1080 } },
  });
}
